<template>
    <modal :title="setModel!=undefined?'Update Hotel':'Add Hotel Group'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem" ref="form">
                <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true,max:50}" @keydown.enter="save"></formGroup>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :process="process">{{setModel!=undefined?'Update Hotel Group':'Add Hotel Group'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            setModel:Object
        },
        data(){
            return{
                model:{
                    Id: null,
                    Name: ""
                },
                errs:{

                },
                process:false
            }
        },
        created(){
            if(this.setModel!=undefined){
                this.model={...this.setModel};
            }
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`HotelGroups`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"The hotel group has been successfully updated.":"The hotel group has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=undefined){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>